"use client";

import { ContentState } from "@/components/content-state";
import { Button } from "@/components/ui/button";

export default function AppError({ reset }: { reset: () => void }) {
  return <main className="mx-auto w-full max-w-3xl p-6"><ContentState kind="error" description="Não foi possível carregar o painel. Tente novamente." action={<Button onClick={reset}>Tentar novamente</Button>} /></main>;
}
